
var BOLD = window.BOLD = (window.BOLD || {});
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.DisableFormScript = function (currentForm) {
  const config = { attributes: true, childList: true, subtree: true , characterData: true};
  var oldFormIsValid = true;
  let timerRunning = false;
  const checkOutButtons = currentForm.querySelectorAll('input[name="checkout"], button[name="checkout"], input[name="goto_pp"], button[name="goto_pp"], input[name="goto_gc"]');
  checkOutButtons.forEach((ele) => {ele.removeAttribute("disabled")});


  const timerCallback = () => {
    const phoneNumberElement = currentForm.querySelector('#fnd_phone_number input');
    const formAttributeElements = currentForm.querySelectorAll('[name^="attributes"].required, [name^="attributes"][required ="required"]');
    var formIsValid = true;

    formAttributeElements.forEach(function (a) {
      if (formIsValid && (a.value == "" || a.value == null)) {
        formIsValid = false;
      }
    });

    const phoneVerificationRegex = /\(?\d\d\d\)?(-| ?)\d\d\d(-| ?) ?\d\d\d\d/;   // https://regex101.com/r/qGXywx/1
    if(!phoneVerificationRegex.test(phoneNumberElement.value)) {
      formIsValid = false;
    }
    if (oldFormIsValid!=formIsValid) {
      const checkOutButtons = currentForm.querySelectorAll('input[name="checkout"], button[name="checkout"], input[name="goto_pp"], button[name="goto_pp"], input[name="goto_gc"]');
      if (formIsValid) {
        checkOutButtons.forEach((ele) => {ele.classList.remove("disabled")});
      }else{
        checkOutButtons.forEach((ele) => {ele.classList.add("disabled")});
      }
    }
    oldFormIsValid = formIsValid;
    timerRunning = false;
  };
  const mutationCallback = () => {
    if (!timerRunning) {
      timerRunning = true;
      setTimeout(timerCallback,100);
    }
  };
  const observer = new MutationObserver(mutationCallback);
  observer.observe(currentForm, config);
  currentForm.addEventListener("input", mutationCallback);
}
BOLD.BMS.LocalDeliveryScript = function ($) {
// var localDeliveryScript = function ($) {
  function getDefaultRequestConfig() {
    return JSON.parse(
      JSON.stringify({
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json;'
        }
      })
    );
  }
  function fetchJSON(url, config) {
    return fetch(url, config).then(function(response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  function sendCartAttributes(form) {
    let attributes = {};
    const len = ("attributes[").length;
    form.querySelectorAll('[name^="attributes"]').forEach((ele)=>{
      attributes[ele.name.substr(len,ele.name.length-len-1)] = ele.value
    })
    var config = getDefaultRequestConfig();

    config.method = 'POST';
    config.body = JSON.stringify({
      attributes: attributes
    });

    return fetchJSON('/cart/update.js', config);
  }
  $(function () {
    function unavailable(date) {
      var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      var ymd = date.getFullYear() + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + ("0" + date.getDate()).slice(-2);
      var day = new Date(ymd).getDay();

      for (var i = 0; i < unavailableDates.length; i++) {
        if ((ymd >= unavailableDates[i].start_at) && (ymd <= unavailableDates[i].end_at)) {
          return [false, "disabled", dayDisabledMessage];
        }
      }

      if ($.inArray(days[day], unavailableDays) >= 0) {
        return [false, "disabled", dayDisabledMessage];
      }

      var now = new Date();

      if (now.toDateString() === date.toDateString()) {
        var dayOfWeek = date.getDay();
        var endTime = new Date(date.toDateString() + ' ' + deliveryHours[(dayOfWeek * 2) + 1]);

        now.setUTCHours(now.getUTCHours() + minimumHourOffset)

        if (now > endTime) {
          return [false, "disabled", dayDisabledMessage];
        }
      }


      return [true, "enabled", dayEnabledMessage];

    }

    function convertHourToAMPM(hour) {
      var ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12;
      hour = hour ? hour : 12;
      return hour + ':00' + ' ' + ampm;
    }

    function getAvailableTimesLiquid(date) {
      var dayOfWeek = date.getDay();

      var startTime = new Date(date.toDateString());
      var endTime = new Date(date.toDateString());

      startTime.setHours(deliveryHours[dayOfWeek * 2].slice(0, -3));
      endTime.setHours(deliveryHours[dayOfWeek * 2 + 1].slice(0, -3));

      var minTime = new Date();

      minTime.setHours(minTime.getHours() + minimumHourOffset);

      if (minTime > startTime) {
        startTime = minTime;
      }

      $('#timeDiv').show();
      var mySelect = $('#local_delivery');
      mySelect.empty();

      var i = 0;
      for (i = startTime; i < endTime; i.setMinutes(i.getMinutes() + 60)) {
        var end = new Date(i);
        end.setMinutes(end.getMinutes() + 60);
        end = new Date(i);
        end.setMinutes(end.getMinutes() + 60);

        var val = i.toDateString() + ' between ' + convertHourToAMPM(i.getHours()) + ' and ' + convertHourToAMPM(end.getHours());
        var text = convertHourToAMPM(i.getHours()) + ' to ' + convertHourToAMPM(end.getHours());

        mySelect.append($('<option></option>').val(val).html(text));
      }

      if (mySelect.has('option').length <= 0) {
        alert(noSlotsMessage);
        $('#timeDiv').hide();
      }
    }

    function getAvailableTimesLiquidAllDay(date) {
      var dayOfWeek = date.getDay();

      var startTime = new Date(date.toDateString());
      var endTime = new Date(date.toDateString());

      startTime.setHours(deliveryHours[dayOfWeek * 2].slice(0, -3));
      endTime.setHours(deliveryHours[dayOfWeek * 2 + 1].slice(0, -3));

      var mySelect = $('#local_delivery');
      mySelect.empty();

      var val = startTime.toDateString() + ' between ' + convertHourToAMPM(startTime.getHours()) + ' and ' + convertHourToAMPM(endTime.getHours());
      var text = convertHourToAMPM(startTime.getHours()) + ' to ' + convertHourToAMPM(endTime.getHours());

      mySelect.append($('<option></option>').val(val).html(text));
    }

    function getAvailableTimesServer(date) {
      $("#loading").show();
      var version = (typeof (localDeliveryVersion) == 'undefined') ? 1 : localDeliveryVersion;
      var localDeliveryURL = (version == 2) ? 'https://localdelivery.herokuapp.com/delivery_slots.json' : 'https://localdelivery.herokuapp.com/slots.json';
      $.ajax({
        url: localDeliveryURL,
        dataType: 'jsonp',
        data: {
          "url": Shopify.shop,
          "date": date
        },
        contentType: 'application/json',
        timeout: 20000,
        success: function (data, status, xhr) {
          $("#loading").hide();
          $('#timeDiv').show();

          // update the select
          var mySelect = $('#local_delivery');
          mySelect.empty();

          for (var i = 0; i < data.length; i++) {
            var text = data[i];
            var val = date.toDateString() + ' between ' + text.replace("to", "and");
            mySelect.append($('<option></option>').val(val).html(text));
          }

          if (mySelect.has('option').length <= 0) {
            alert(noSlotsMessage);
            $('#timeDiv').hide();
          }

          postTimeCallBack($);

        },
        error: function (xhr, status, error) {
          $("#loading").hide();
          // error occured - just use the core hours
          getAvailableTimesLiquid(date);
        }
      });
    }

    $("#loading").hide();

    var minimumHourOffset = (typeof (minimumHour) === 'undefined') ? 0 : minimumHour;
    var postSelectCallBack = (typeof (ldPostSelectCallBack) === 'undefined') ? function () {} : ldPostSelectCallBack;
    var postTimeCallBack = (typeof (ldpostTimeCallBack) === 'undefined') ? function () {} : ldpostTimeCallBack;
    var postDateInitCallBack = (typeof (ldPostDateInitCallBack) === 'undefined') ? function () {} : ldPostDateInitCallBack;
    var noSlotsMessage = (typeof (ldNoSlotsMessage) === 'undefined') ? "no slots available" : ldNoSlotsMessage;
    var dayDisabledMessage = (typeof (ldDayDisabledMessage) === 'undefined') ? "Booked Out" : ldDayDisabledMessage;
    var dayEnabledMessage = (typeof (ldDayEnabledMessage) === 'undefined') ? "Book Now" : ldDayEnabledMessage;
    var shopTime = (typeof (ldshopTime) === 'undefined') ? Date() : ldshopTime;
    function waitForElm(selector) {
      return new Promise(resolve => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }
    function perForm(currentForm) {
      BOLD.BMS.DisableFormScript(currentForm);
      let datePickerAttempts = 0;
      function datepickerAttempt() {
        try {
          $(currentForm).find("#datepicker").datepicker({
            onSelect: function (dateText, inst) {
              var date = new Date(dateText);
              var version = (typeof (localDeliveryVersion) == 'undefined') ? 1 : localDeliveryVersion;

              if (rateLimitEnabled || (version == 2)) {
                getAvailableTimesServer(date);
              } else if ((typeof (allDayEnabled) === 'undefined') ? false : allDayEnabled) {
                getAvailableTimesLiquidAllDay(date);
              } else {
                getAvailableTimesLiquid(date);
              }

              // do callback for post select generation
              postSelectCallBack($, dateText, inst);

            },
            beforeShowDay: unavailable,
            minDate: typeof (minimumDate) == 'undefined' ? 0 : minimumDate,
            maxDate: typeof (maximumDate) == 'undefined' ? null : maximumDate,
            dateFormat: typeof (dateFormat) == 'undefined' ? "yy/mm/dd" : dateFormat
          });
        } catch (error) {
          datePickerAttempts++;
          console.log(error)
          if (datePickerAttempts < 10) {
            setTimeout(datepickerAttempt,1000)
          }
        }
      }
      $(function () {datepickerAttempt();});
      // do callback for post datepicker init
      postDateInitCallBack($);

      $(function () {
        $(currentForm).find('input[name="checkout"], button[name="checkout"], input[name="goto_pp"], button[name="goto_pp"], input[name="goto_gc"]').click(function () {
          var formIsValid = true;
          var message = "Please select a delivery date and time.";
          $(currentForm).find('[name^="attributes"]').filter('.required, [required ="required"]').each(function () {
            $(this).removeClass('error');
            if (formIsValid && ($(this).val() == "" || $(this).val() == null)) {
              formIsValid = false;
              message = $(this).attr('data-error') || message;
              $(this).addClass('error');
            }
          });
          const phoneNumberElement = currentForm.querySelector('#fnd_phone_number input');
          const phoneVerificationRegex = /\(?\d\d\d\)?(-| ?)\d\d\d(-| ?) ?\d\d\d\d/;   // https://regex101.com/r/qGXywx/1
          if(!phoneVerificationRegex.test(phoneNumberElement.value)) {
            formIsValid = false;
            message = $(phoneNumberElement).attr('data-error') || message;
            $(phoneNumberElement).addClass('error');
          }
          if (formIsValid) {
            sendCartAttributes(currentForm).finally(()=>{
              setTimeout(() => {
                $(this).submit();
              }, 1)

            });
          } else {
            alert(message);
            return false;
          }
        });
      });
    }
    waitForElm(".js-cart-form").then(perForm);
  });
};
document.addEventListener("DOMContentLoaded",function() {
  function waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
  waitForElm(".js-cart-form").then((form) => {BOLD.BMS.DisableFormScript(form)});
});